import { Link, useNavigate } from "react-router-dom"
import { Footer } from "../../Footer/Footer"
import { HerosectionsAll } from "../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../IndexPage/Header/Header"


export const Consultancy = ({ actives }) => {
    const navigate = useNavigate()
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="Consultancy" subactive="Services" />
                    <HerosectionsAll ScreenName="Consultancy" ScreenSearch="Consultancy" />

                    <div className="row p-lg-4 mb-lg-5">


                        {/* <div className="col-12 col-lg-4  p-3">
                            <div className=" consutancy_three2 shadow2">
                                <h5 className="text-white p-3 mb-3 ">Operational Risk Management</h5>

                                <div className="row cursor_pointer ps-3 pt-3"
                                    onClick={() => navigate('/MaritimeOperationalRiskManagement?ScreenName=Maritime Operational Risk Management&Name=Services&SubName=Consultancy')}>
                                    <div className="col-2">
                                        <img src="Static/Assets/Img/push-pin-01.png" className="px-2" alt="" srcset="" />
                                    </div>
                                    <div className="col-10">
                                        Maritime Operational Risk Management
                                    </div>
                                </div>

                                <div className="row cursor_pointer ps-3 pt-3"
                                    onClick={() => navigate('/CasualtyRespone?ScreenName=Casualty Respone&Name=Services&SubName=Consultancy')}>
                                    <div className="col-2">
                                        <img src="Static/Assets/Img/push-pin-01.png" className="px-2" alt="" srcset="" />
                                    </div>
                                    <div className="col-10">
                                        Casualty Respone
                                    </div>
                                </div>

                                <div className="row cursor_pointer ps-3 pt-3"
                                    onClick={() => navigate('/DISPUTEPREVENTIONANDRESOLUTIONADVISORYSERVICES?ScreenName=DISPUTE PREVENTION AND RESOLUTION ADVISORY SERVICES&Name=Services&SubName=Consultancy')}>
                                    <div className="col-2">
                                        <img src="Static/Assets/Img/push-pin-01.png" className="px-2" alt="" srcset="" />
                                    </div>
                                    <div className="col-10">
                                        Dispute Prevention & Resolution Advisory Services
                                    </div>
                                </div>


                            </div>
                        </div> */}

                        {/* <div className="col-12 col-lg-4  p-3">
                            <div className=" consutancy_three2 shadow2">
                                <h5 className="text-white p-3 mb-3 " >Claims Consultancy</h5>

                                <div className="row cursor_pointer ps-3 pt-3"
                                    onClick={() => navigate('/CargoClaim?ScreenName=Cargo Claim&Name=Services&SubName=Consultancy')}>
                                    <div className="col-2">
                                        <img src="Static/Assets/Img/push-pin-01.png" className="px-2" alt="" srcset="" />
                                    </div>
                                    <div className="col-10">
                                        Cargo Claim
                                    </div>
                                </div>
                                <div className="row cursor_pointer ps-3 pt-3"
                                    onClick={() => navigate('/HullClaim?ScreenName=Hull Claim&Name=Services&SubName=Consultancy')}>
                                    <div className="col-2">
                                        <img src="Static/Assets/Img/push-pin-01.png" className="px-2" alt="" srcset="" />
                                    </div>
                                    <div className="col-10">
                                        Hull Claim
                                    </div>
                                </div>

                                <div className="row cursor_pointer ps-3 pt-3"
                                    onClick={() => navigate('/ShipRepairsLiabilityClaims?ScreenName=Ship Repairs Liability Claims&Name=Services&SubName=Consultancy')}>
                                    <div className="col-2">
                                        <img src="Static/Assets/Img/push-pin-01.png" className="px-2" alt="" srcset="" />
                                    </div>
                                    <div className="col-10">
                                        Ship Repairs Liability Claims
                                    </div>
                                </div>

                                <div className="row cursor_pointer ps-3 pt-3"
                                    onClick={() => navigate('/LossofHireClaims?ScreenName=Loss of Hire Claims&Name=Services&SubName=Consultancy')}>
                                    <div className="col-2">
                                        <img src="Static/Assets/Img/push-pin-01.png" className="px-2" alt="" srcset="" />
                                    </div>
                                    <div className="col-10">
                                        Loss of Hire Claims
                                    </div>
                                </div>

                                <div className="row cursor_pointer ps-3 pt-3"
                                    onClick={() => navigate('/BuilderRisksClaims?ScreenName=Builder’s Risks  Claims&Name=Services&SubName=Consultancy')}>
                                    <div className="col-2">
                                        <img src="Static/Assets/Img/push-pin-01.png" className="px-2" alt="" srcset="" />
                                    </div>
                                    <div className="col-10">
                                        Builder’s Risks Claims
                                    </div>
                                </div>

                            </div>
                        </div> */}

                        <div className="col-12 col-lg-4 p-2 pb-lg-5">
                            <div className=" consutancy_three2 p-2 p-lg-3">
                                <div className="row cursor_pointer  pt-5 Professional_img">
                                    <h5 className="text-white text-center pt-5 Professional ">
                                        Operational Risk Management </h5>
                                    <ul className="ps-lg-4">

                                        <li className="pb-2 ms-5 ms-lg-4"
                                            onClick={() => navigate('/MaritimeOperationalRiskManagement?ScreenName=Maritime Operational Risk Management&Name=Services&SubName=Consultancy')}
                                        > Maritime Operational Risk Management </li>

                                        <li className="py-2 ms-5 ms-lg-4"
                                            onClick={() => navigate('/CasualtyRespone?ScreenName=Casualty Respone&Name=Services&SubName=Consultancy')}
                                        > Casualty Response </li>

                                        <li className="py-2 ms-5 ms-lg-4"
                                            onClick={() => navigate('/DISPUTEPREVENTIONANDRESOLUTIONADVISORYSERVICES?ScreenName=DISPUTE PREVENTION AND RESOLUTION ADVISORY SERVICES&Name=Services&SubName=Consultancy')}
                                        > Dispute Prevention & Resolution Advisory Services </li>

                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div className="col-12 col-lg-4  p-2  pb-lg-5">
                            <div className=" consutancy_three2 p-2 p-lg-3">
                                <div className="row cursor_pointer  pt-5 Professional_img">
                                    <h5 className="text-white text-center pt-5 Professional ">
                                        Claims Consultancy </h5>
                                    <ul className="ps-lg-4">

                                        <li className="py-2 ms-5 ms-lg-4"
                                            onClick={() => navigate('/CargoClaim?ScreenName=Cargo Claim&Name=Services&SubName=Consultancy')}
                                        >Cargo Claim</li>

                                        <li className="py-2 ms-5 ms-lg-4"
                                            onClick={() => navigate('/HullClaim?ScreenName=Hull Claim&Name=Services&SubName=Consultancy')}
                                        >Hull Claim</li>

                                        <li className="py-2 ms-5 ms-lg-4"
                                            onClick={() => navigate('/GeneralAverageClaims?ScreenName=General Average Claims&Name=Services&SubName=Consultancy')}
                                        >General Average Claims</li>

                                        <li className="py-2 ms-5 ms-lg-4"
                                            onClick={() => navigate('/CollisionLiability?ScreenName=Collision Liability&Name=Services&SubName=Consultancy')}
                                        >Collision Liability</li>

                                        <li className="py-2 ms-5 ms-lg-4"
                                            onClick={() => navigate('/ShipRepairsLiabilityClaims?ScreenName=Ship Repairs Liability Claims&Name=Services&SubName=Consultancy')}
                                        >Ship Repairs Liability Claims</li>

                                        <li className="py-2 ms-5 ms-lg-4"
                                            onClick={() => navigate('/LossofHireClaims?ScreenName=Loss of Hire Claims&Name=Services&SubName=Consultancy')}
                                        >Loss of Hire Claims</li>

                                        <li className="py-2 ms-5 ms-lg-4"
                                            onClick={() => navigate('/BuilderRisksClaims?ScreenName=Builder’s Risks  Claims&Name=Services&SubName=Consultancy')}
                                        >Builder’s Risks Claims </li>

                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div className="col-12 col-lg-4  p-2  pb-lg-5">
                            <div className=" consutancy_three2 p-2 p-lg-3">
                                <div className="row cursor_pointer  pt-5 Professional_img">
                                    <h5 className="text-white text-center pt-5 Professional ">
                                        Valuation and Forensic Audit </h5>
                                    <ul className="ps-lg-4">
                                        <li className="pb-2 ms-5 ms-lg-4"
                                            onClick={() => navigate('/Valuation?ScreenName=Valuation=Services&Name=Services&SubName=Consultancy')}
                                        >Valuation</li>
                                        <li className="py-2 ms-5 ms-lg-4"
                                            onClick={() => navigate('/FORENSICAUDIT?ScreenName=FORENSICAUDIT&Name=Services&SubName=Consultancy')}
                                        >  Forensic Audit </li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                        {/* <div className="col-12 col-lg-4  p-3">
                            <div className=" consutancy_three2 shadow2">
                                <h5 className="text-white p-3 mb-3 ">Valuation and Forensic Audit</h5>

                                <div className="row cursor_pointer ps-3 pt-3"
                              >
                                    <div className="col-2">
                                        <img src="Static/Assets/Img/push-pin-01.png" className="px-2" alt="" srcset="" />
                                    </div>
                                    <div className="col-10">
                                        Valuation
                                    </div>
                                </div>
                                <div className="row cursor_pointer ps-3 pt-3"
                                >
                                    <div className="col-2">
                                        <img src="Static/Assets/Img/push-pin-01.png" className="px-2" alt="" srcset="" />
                                    </div>
                                    <div className="col-10">
                                        Forensic Audit
                                    </div>
                                </div>



                            </div>
                        </div> */}

                        {/* <div className="col-12 col-lg-4  p-3">
                            <div className="p-4 consutancy_three rounded">
                                <h5 className="" style={{ color: '#d98914' }}>Claims Consultancy </h5>
                                <ul className="ps-2">
                                    <li className="cursor_pointer" onClick={() => navigate('/CargoClaim?ScreenName=Cargo Claim&Name=Services&SubName=Consultancy')}><i class="fa-solid fa-stop pe-2"></i>  Cargo Claim</li>

                                    <li className="cursor_pointer" onClick={() => navigate('/HullClaim?ScreenName=Hull Claim&Name=Services&SubName=Consultancy')}><i class="fa-solid fa-stop pe-2"></i>  Hull Claim </li>

                                    <li className="cursor_pointer" onClick={() => navigate('/ShipRepairsLiabilityClaims?ScreenName=Ship Repairs Liability Claims&Name=Services&SubName=Consultancy')}><i class="fa-solid fa-stop pe-2"></i>  Ship Repairs Liability Claims</li>

                                    <li className="cursor_pointer" onClick={() => navigate('/LossofHireClaims?ScreenName=Loss of Hire Claims&Name=Services&SubName=Consultancy')}><i class="fa-solid fa-stop pe-2"></i>  Loss of Hire Claims </li>

                                    <li className="cursor_pointer" onClick={() => navigate('/BuilderRisksClaims?ScreenName=Builder’s Risks  Claims&Name=Services&SubName=Consultancy')}><i class="fa-solid fa-stop pe-2"></i>  Builder’s Risks Claims</li>
                                    <li className="cursor_pointer" > <i class="fa-solid fa-stop pe-2"></i>   Ship builder's Liability </li>
                                </ul>
                            </div>
                        </div> */}

                        {/* <div className="col-12 col-lg-4  p-3">
                            <div className="p-4 consutancy_three rounded">
                                <h5 className="" style={{ color: '#d98914' }}>Valuation and Forensic Audit </h5>
                                <ul className="ps-2">
                                    <li>Valuation </li>
                                    <li>Forensic Audit </li>
                                </ul>
                            </div>
                        </div> */}

                    </div>



                    {/* <div className="row p-2 p-lg-5  mx-auto text-center">
                        <div className="col-12">
                            <h3 className="green fw-bold text-center"> Consultancy </h3>

                            <div className="col-8 mb-3 col-lg-3 mx-auto  zoom-in-out-box2 text-center">
                                <hr />
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 pt-lg-3" >
                            <div className="row  rounded pb-4 px-lg-2">
                                <div className="col-12 col-md-6 col-lg-3 px-4 pt-4">
                                    <div className="row p-3 consultancy_services">
                                        <div className="col-10">
                                            Maritime Operational Risk Management
                                        </div>
                                        <div className="col-2">
                                            <i class="fa-solid fa-circle-arrow-right fs-4"></i>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3 px-4 pt-4" >
                                    <div className="row p-3 consultancy_services">
                                        <div className="col-10">
                                            Casualty Respone
                                        </div>
                                        <div className="col-2">
                                            <i class="fa-solid fa-circle-arrow-right fs-4"></i>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3 px-4 pt-4">
                                    <div className="row p-3 consultancy_services">
                                        <div className="col-10">
                                            Insurance Dispute, Prevention & Resolution
                                        </div>
                                        <div className="col-2">
                                            <i class="fa-solid fa-circle-arrow-right fs-4"></i>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3 px-4 pt-4">
                                    <div className="row p-3 consultancy_services">
                                        <div className="col-10">
                                            Web Marketing
                                        </div>
                                        <div className="col-2">
                                            <i class="fa-solid fa-circle-arrow-right fs-4"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-lg-12 ">
                            <div className="row rounded px-lg-2 pb-4">
                                <div className="col-12 col-md-6 col-lg-3 px-4 pt-4">
                                    <div className="row p-3 consultancy_services"
                                        onClick={() => navigate('/CargoClaim?ScreenName=Cargo Claim&Name=Services&SubName=Learning And Development')}>
                                        <div className="col-10">
                                            Cargo Claim
                                        </div>
                                        <div className="col-2">
                                            <i class="fa-solid fa-circle-arrow-right fs-4"></i>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3 px-4 pt-4">
                                    <div className="row p-3 consultancy_services"
                                        onClick={() => navigate('/HullClaim?ScreenName=Hull Claim&Name=Services&SubName=Learning And Development')}>
                                        <div className="col-10">
                                            Hull Claim
                                        </div>
                                        <div className="col-2">
                                            <i class="fa-solid fa-circle-arrow-right fs-4"></i>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3 px-4 pt-4">
                                    <div className="row p-3 consultancy_services"
                                        onClick={() => navigate('/ShipRepairsLiabilityClaims?ScreenName=Ship Repairs Liability Claims&Name=Services&SubName=Learning And Development')}>
                                        <div className="col-10">
                                            Ship Repairs Liability Claims
                                        </div>
                                        <div className="col-2">
                                            <i class="fa-solid fa-circle-arrow-right fs-4"></i>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3 px-4 pt-4">
                                    <div className="row p-3 consultancy_services"
                                        onClick={() => navigate('/LossofHireClaims?ScreenName=Loss of Hire Claims&Name=Services&SubName=Learning And Development')}>
                                        <div className="col-10">
                                            Loss of Hire Claims
                                        </div>
                                        <div className="col-2">
                                            <i class="fa-solid fa-circle-arrow-right fs-4"></i>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3 px-4 pt-4">
                                    <div className="row p-3 consultancy_services"
                                        onClick={() => navigate('/BuilderRisksClaims?ScreenName=Builder’s Risks  Claims&Name=Services&SubName=Learning And Development')}>
                                        <div className="col-10">
                                            Builder’s Risks  Claims
                                        </div>
                                        <div className="col-2">
                                            <i class="fa-solid fa-circle-arrow-right fs-4"></i>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3 px-4 pt-4">
                                    <div className="row p-3 consultancy_services">
                                        <div className="col-10">
                                            Ship builder's Liability
                                        </div>
                                        <div className="col-2">
                                            <i class="fa-solid fa-circle-arrow-right fs-4"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div> */}



                    <Footer />
                </div>
            </div>

</div>
        </>
    )
}
